/** Copyright �2013 Renoworks, Inc. All rights reserved. www.Renoworks.com
 *
 * @param {jQuery} $ A reference to the jQuery object.
 */
(function ($) {
  Renoworks = window.Renoworks || {};
  Renoworks.ShareUpdate = new ShareUpdate();

  function ShareUpdate() {}
  Renoworks.emailOnce = true;
  ShareUpdate.prototype.doShare = function (type, email, id) {
    var project,
      render,
      product;
    if (id) { // Design ID
      var design = Renoworks.User.getDesign(id);
      if (design) {
        project = design.tag + '/' + design.folder;
        render = design.render;

        var products = [];
        for (var key in design.palette) {
          design.palette[key].name = key;
          products.push(design.palette[key]);
        }
      }
    } else if (Renoworks.ProjectController.isProjectSet() && Renoworks.ProjectController.isDesigned()) {
      project = Renoworks.ProjectController.getProjectName();
      render = project + '/images' + Renoworks.ProjectController.getProjectRender() + '.jpg';
      var products = Renoworks.ProjectController.getProduct();
    }
    if (products) {
      shareProduct(type, email, project, render, products);
    } else {
      Renoworks.Notify.notDesigned();
    }
  };

  function shareProduct(type, email, project, render, products) {
    if (project) {
      var host;
      var targetUrl = document.URL;
      if (targetUrl.indexOf('?') != -1) {
        host = targetUrl.substring(0, targetUrl.indexOf('?'));
      } else {
        host = targetUrl.replace(/#/g, '');
      }
      targetUrl = host + 'design/loading.html';
      if (type != 'email') {
        var shareWindow = window.open(targetUrl, '_blank');
      }
      var product = Renoworks.ShareUpdate.createProductString(products);
      var description = Renoworks.LocaleController.getValueForKey('check_des'); // TODO - load this from client
      $.ajax({
        type: 'POST',
        url: 'ShareProject',
        data: {
          site: Renoworks.client,
          project: project,
          render: render,
          product: product,
          locale: Renoworks.LocaleController.getLocale(),
          type: 'dynamic',
          fullImagePath: render,
        },
        success: function (data) {
          targetUrl = host + 'design/?id=' + data;
          if (type == 'pinterest') {
            var params = {
              url: targetUrl,
              media: host + 'data/' + Renoworks.client + '/projects/' + render,
              description: description,
            };

            shareWindow.location.href = 'http://pinterest.com/pin/create/button/?' + $.param(params);
          } else if (type == 'facebook') {
            var params = {
              u: targetUrl,
            };
            shareWindow.location.href = 'http://www.facebook.com/sharer.php?' + $.param(params);
          } else if (type == 'twitter') {
            var params = {
              url: targetUrl,
              text: description,
            };

            shareWindow.location.href = 'http://www.twitter.com/intent/tweet/?' + $.param(params);
          } else if (type == 'google') {
            var params = {
              url: targetUrl,
            };

            shareWindow.location.href = 'http://plus.google.com/share?' + $.param(params);
          } else if (type == 'email') {
            if (Renoworks.emailOnce) {
              Renoworks.emailOnce = false;
              $('#loading, .loading').show();
              $.ajax({
                type: 'POST',
                url: 'EmailProject',
                data: {
                  site: Renoworks.client.toLowerCase(),
                  id: data,
                  email: email,
                  locale: Renoworks.LocaleController.getLocale(),
                },
                success: function (resp) {
                  $('.loading_modal').hide();
                  $(Renoworks.Event).trigger({
                    type: Renoworks.Event.EMAIL_TO_FRIEND_SUCCESS,
                  });
                },
              });
            }
          } else if (type == 'print') {
            targetUrl += '&print=true';
            shareWindow.location.href = targetUrl;
          }
        },
      });
    } else if (!Renoworks.ProjectController.isProjectSet()) {
      var html = '<p class="locale_html" data-locale-id="choose_proj">' + Renoworks.LocaleController.getValueForKey('choose_proj') + '</p>';
      var title = '<div class="locale_html" data-locale-id="share">' + Renoworks.LocaleController.getValueForKey('share') + '</div>';
      var classes = 'notice';
      var buttons = [];
      var button = new Renoworks.Button();
      button.name = 'Ok';
      button.classes = 'btn';
      button.callback = function () {
        $('.modal').click();
      };
      buttons.push(button);
      Renoworks.Notify.show(html, title, classes, buttons);
    } else if (!Renoworks.ProjectController.isDesigned()) {
      Renoworks.Notify.notDesigned();
    }
  }

  ShareUpdate.prototype.createProductString = function (products) {
    var layers = Renoworks.ProjectController.getLayers();
    var productStrings = [];
    var rendered = 0,
      toRender = 0;
    // Add each product to the productString
    var complete = false;
    for (var k = 0; k < layers.length; k++) {
      if (layers[k].layerType != 'RWForeground') {
        for (var i = 0; i < products.length; i++) {
          if (products[i].name != '' && products[i].name.toLowerCase().indexOf('foreground') == -1) { // shiv, not sure why there is foreground product with gridsettings
            var productString = '';
            var product = products[i];

            var attributes = product.data.split('||');
            var attrStart = false;
            // Add each attribute of the product to the productString
            for (var j = 0; j < attributes.length; j++) {
              var attribute = attributes[j].split('=');
              var key = attribute[0];
              var value = attribute[1];
              product[key] = value;
            }

            if (product.type != 'color') { // colors don't belong to any rwd's
              productString += 'productType=Door||';
            } else {
              var productName = product.name;
              var type;
              for (var p = 0; p < layers.length; p++) {
                if (layers[p].name == productName) {
                  type = layers[p].type;
                  break;
                }
              }

              productString += 'productType=' + type + '||';
            }

            if (product.layerName) {
              if (Renoworks.ProjectController.getTag() == 'sample') {
                productString += 'layerName=' + Renoworks.LocaleController.getValueForKey(product.layerName.toLowerCase().replace(' ', '_')) + '||';
              } else {
                productString += 'layerName=' + product.layerName + '||';
              }
            } else if (product.name) {
              productString += 'layerName=' + product.name + '||';
            }

            // Add the product rendered image to the product string
            if (product.type == 'grid') {
              var grid = Renoworks.ProductController.getProductByRWD(product.rwd);
              grid.selectByGridSettings(product.gridSettings);
              if (Renoworks.LocaleController.getLocale() == 'fr') {
                productString += grid.getData() + '||productImage=' + Renoworks.ShareUpdate.renderGridSync(grid, 200, 600, 600);
              } else {
                // grid.renderedImage
                var xPath = $('#sub_header_menu ul li[data-label="Style"]').attr('xpath');
                var collection = xPath.split("[@name='")[1].split("']/")[0];
                var gridProdStr = 'Collection=' + collection + '||';
                gridProdStr += 'Style=' + grid.name + '||';
                for (var z = 0; z < grid.tabs.length; z++) {
                  var tab = grid.tabs[z];
                  if (tab.visible == '1') {
                    gridProdStr += tab.name + '=';
                    if (tab.selectedGrid != null) {
                      gridProdStr += tab.selectedGrid.name + '||';
                    } else {
                      gridProdStr += 'None||';
                    }
                  }
                }
                // grid.getData()
                productString += gridProdStr + 'productImage=' + Renoworks.ShareUpdate.renderGridSync(grid, 200, 600, 600);
              }
            }
            // Add the swatch thumbnail if the product is not multigrid
            else if (product.type == 'tile') {
              // Go through the product getting the building the string
              productString += product.data;

              // Get the swatch path for the product
              var tileProduct = Renoworks.ProductController.getProductByRWD(product.rwd);
              if (Renoworks.LocaleController.getLocale() == 'fr') {
                productString += '||style=' + tileProduct.name_fr;
              } else {
                productString += '||style=' + tileProduct.name;
              }

              var swatch = tileProduct.getSwatchByColor(product.color);
              var swatchPath = 'data/' + Renoworks.client + '/product/' + tileProduct.folder + '/' + swatch;
              productString += '||productImage=' + swatchPath;
            } else if (product.type == 'color') {
              productString += '||Color=#' + product.data; // product.data is the hex value of the color
              productString += '||productImage=#' + product.data; // hex value handled on design report page
            } else {
              // console.log('Design report non-tile non-grid product');
            }

            productStrings[i] = productString;
          }
        }
      }
    }

    productString = '';
    // Concatenate all the product strings
    var started = false;
    for (var key in productStrings) {
      if (started) {
        productString += ',,';
      }
      productString += productStrings[key];
      started = true;
    }

    productString = productString.replace(new RegExp('\\~', 'g'), '');
    // console.log(productString);
    return productString;
  };

  /**
     * Copied from gridObject to avoid events so print wouldn't be blocked.  TODO - core code should be modified
     * to handle this case
     */
  ShareUpdate.prototype.renderGridSync = function (grid, projectPpf, maxWidth, maxHeight, async, div) {
    var rWidth = grid.width,
      rHeight = grid.height;
    if (!async) {
      async = false;
    }
    // Constrain width/height
    if (maxWidth != null) {
      if (maxHeight == null) {
        maxHeight = maxWidth;
      }
      var ratio = grid.width / grid.height;
      if (ratio * maxHeight > maxWidth) {
        rWidth = maxWidth;
        rHeight = maxWidth / ratio;
      } else {
        rHeight = maxHeight;
        rWidth = maxHeight * ratio;
      }
    }

    // Create grid settings
    var gridSettings = '';
    for (var i = 0; i < grid.tabs.length; i++) {
      if (grid.tabs[i].selectedGrid) {
        gridSettings += grid.tabs[i].selectedGrid.guid;
        if (grid.tabs[i].selectedGrid.selectedColor) {
          gridSettings += ',' + grid.tabs[i].selectedGrid.selectedColor.guid;
        }
      }
      if (i < grid.tabs.length - 1) {
        gridSettings += ',';
      }
    }

    // Default ppf
    if (!projectPpf) {
      projectPpf = 80;
    }

    // Render
    var renderedImage = '';
    $.ajax({
      type: 'POST',
      url: 'RenderGrid',
      data: {
        rwd: grid.rwd,
        gridSettings: gridSettings,
        width: parseInt(rWidth),
        height: parseInt(rHeight),
        site: Renoworks.client,
        ppf: projectPpf,
        // cache: 'true'
      },
      async: async,
      success: function (data) {
        if (data) {
          renderedImage = 'data/' + Renoworks.client + '/' + data;
          grid.renderedImage = renderedImage;
          if (async) {
            div.find('.review_image').css('background-image', 'url(' + renderedImage + ')');
            $('.productSpinner').hide();
          }
        }
      },
    });

    return renderedImage;
  };
}(jQuery));
